/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Dup_Receipt_DescInputs */

const vi_customer_debt_dup_receipt_desc = /** @type {(inputs: Customer_Debt_Dup_Receipt_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có phiếu thu cùng số tiền trong ngày này. Bạn vẫn muốn tạo tiếp?`)
};

/**

* @param {Customer_Debt_Dup_Receipt_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_dup_receipt_desc = /** @type {((inputs?: Customer_Debt_Dup_Receipt_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Dup_Receipt_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_dup_receipt_desc(inputs)
});